



























































































import { Object } from 'lodash'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { ICenter } from '@/store/modules/views/center/states'

@Component
export default class Schedule extends VueExtendedBaseComponent {
  private options: OptionTable = {
    page: 1,
    sortBy: ['date'],
    sortDesc: [false],
    itemsPerPage: 10,
    search: '',
  }
  // private filters = {status: [{condition: 'is not', value: 'รอรับงาน'}]}
  private filters = {}
  private currentData = {}
  private loadingDataTable = true
  private createDialog = false
  private editScheduleDialog = false
  private deleteDialog = false
  private resetDialog = false
  private clearTimeoutValue: NodeJS.Timeout = setTimeout(() => undefined, 100)

  get headers(): Array<{ text: string; value: string }> {
    return this.headerLists
  }

  get items() {
    return this.itemLists
  }

  get paginationLists() {
    return this.pagination
  }

  @Action('schedule/getScheduleList')
  private getScheduleList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
      column: string,
    },
  }) => void

  @Getter('schedule/headerLists')
  private headerLists!: Array<{ text: string; value: string }>

  @Getter('schedule/itemLists')
  private itemLists!: () => void

  @Getter('schedule/pagination')
  private pagination!: () => void

  @Getter('center/centerById')
  private centerById!: {[centerId: string]: ICenter}

  private async callApi() {
    this.loadingDataTable = true
    const column = this.level.mode === 'user' ? ['userName'] : []
    await this.getScheduleList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'date'),
        sortDesc: _.get(this.options, 'sortDesc[0]', false),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify(this.filters)).toString('base64'),
        column: Buffer.from(JSON.stringify(column)).toString('base64'),
      },
    })
    this.loadingDataTable = false
  }

  private doGetLists() {
    clearTimeout(this.clearTimeoutValue)
    this.loadingDataTable = true
    this.clearTimeoutValue = setTimeout(this.callApi, 1000)
  }

  private openDialog(schedule: {name: string, email: string, id: string}, modelDialog: 'editScheduleDialog') {
    this.currentData = _.cloneDeep(schedule)
    this[modelDialog] = true
  }

  get dateNow() {
    return moment().format('YYYY-MM-DD')
  }

  get timeNow() {
    return moment().format('HH:mm:ss')
  }

  private created() {
    this.callApi()
  }
}
